/*
 * V2 CONTENT — new enterprise sections (editable).
 */

export const WHY_VARDHIX = [
  { icon: "Building2", title: "Enterprise Architecture", desc: "Modular, service-oriented systems designed for reliability and long-term maintainability." },
  { icon: "Cloud", title: "Secure Cloud Infrastructure", desc: "Cloud-native deployments with layered security, monitoring and automated recovery." },
  { icon: "MapPin", title: "India-First Technology", desc: "Products engineered for the scale, behaviour and regulatory context of the Indian market." },
  { icon: "Server", title: "High-Performance Backend Systems", desc: "Real-time processing, queue-based workloads and low-latency APIs built to handle volume." },
  { icon: "Layers", title: "Scalable Digital Platforms", desc: "Architecture that grows from thousands to millions of users without re-engineering." },
  { icon: "Sparkles", title: "Continuous Innovation", desc: "Fast iteration, experimentation and constant investment in automation and analytics." },
];

export const LIFECYCLE = [
  { step: "Research", icon: "Eye", desc: "Market, user and technical discovery." },
  { step: "Design", icon: "LayoutGrid", desc: "Architecture, UX and system design." },
  { step: "Development", icon: "Code2", desc: "Engineering with rigorous standards." },
  { step: "Testing", icon: "ShieldCheck", desc: "Automated and manual quality assurance." },
  { step: "Deployment", icon: "Rocket", desc: "Cloud-native, zero-downtime releases." },
  { step: "Scaling", icon: "TrendingUp", desc: "Performance, capacity and reliability." },
  { step: "Continuous Improvement", icon: "RefreshCw", desc: "Monitoring, feedback and iteration." },
];

export const ARCHITECTURE_NODES = [
  { label: "Users", icon: "Users", tier: "Edge" },
  { label: "Cloud", icon: "Cloud", tier: "Edge" },
  { label: "API Gateway", icon: "Zap", tier: "Gateway" },
  { label: "Backend Services", icon: "Server", tier: "Compute" },
  { label: "MongoDB", icon: "Database", tier: "Data" },
  { label: "Redis", icon: "Boxes", tier: "Data" },
  { label: "Analytics", icon: "BarChart3", tier: "Insight" },
  { label: "Admin Portal", icon: "LayoutGrid", tier: "Control" },
  { label: "Monitoring", icon: "Activity", tier: "Control" },
];

export const SECURITY_CARDS = [
  { icon: "ShieldCheck", title: "Secure Infrastructure", desc: "Hardened cloud environments with layered network and application security." },
  { icon: "Eye", title: "Data Protection", desc: "Encryption in transit, access controls and privacy-conscious data handling." },
  { icon: "Activity", title: "High Availability", desc: "Redundancy and failover designed to keep platforms online." },
  { icon: "Layers", title: "Scalable Systems", desc: "Elastic architecture that scales with demand." },
  { icon: "BarChart3", title: "Monitoring", desc: "Real-time observability, alerting and incident response." },
  { icon: "RefreshCw", title: "Continuous Improvements", desc: "Ongoing security reviews and system hardening." },
];

export const INDUSTRIES = [
  { icon: "LineChart", title: "Fintech", desc: "Software infrastructure for financial technology products." },
  { icon: "CircuitBoard", title: "Trading Technology", desc: "Evaluation, simulation and risk systems for market participants." },
  { icon: "Cloud", title: "SaaS", desc: "Multi-tenant, subscription-ready digital products." },
  { icon: "Building2", title: "Enterprise Software", desc: "Internal tools, dashboards and admin systems at scale." },
  { icon: "Workflow", title: "Automation", desc: "Workflow, onboarding and operational automation." },
  { icon: "LayoutGrid", title: "Digital Platforms", desc: "Consumer and business platforms for the Indian market." },
];

export const CAREER_BENEFITS = [
  { icon: "TrendingUp", title: "Growth & Learning", desc: "Learning budgets, mentorship and real ownership from day one." },
  { icon: "MapPin", title: "Flexible Work", desc: "Pune HQ with remote & hybrid options across most roles." },
  { icon: "ShieldCheck", title: "Health & Wellbeing", desc: "Insurance, wellness support and a people-first culture." },
  { icon: "Rocket", title: "Impact at Scale", desc: "Ship products used by thousands across India." },
  { icon: "Users", title: "Great Team", desc: "Work alongside strong engineers, designers and operators." },
  { icon: "Sparkles", title: "Modern Tooling", desc: "Best-in-class stack, hardware and developer experience." },
];

export const HIRING_PROCESS = [
  { step: "Application", desc: "Submit your details and links." },
  { step: "Intro Call", desc: "A conversation about your goals and experience." },
  { step: "Technical Round", desc: "Role-specific discussion or exercise." },
  { step: "Team Interview", desc: "Meet the people you'll work with." },
  { step: "Offer", desc: "We move fast and communicate clearly." },
];

export const LIFE_AT_VARDHIX = [
  "Small teams with real ownership",
  "A culture of craft, speed and integrity",
  "Regular learning sessions and demos",
  "Pune office with a modern workspace",
  "Focus on outcomes over hours",
  "Diverse, inclusive and respectful",
];

export const CONTACT_FAQ = [
  { q: "What does Vardhix Technologies do?", a: "We build and operate fintech software, trading evaluation technologies, business automation systems and scalable digital platforms \u2014 including Capital Tree Funding." },
  { q: "Is Vardhix a stockbroker or investment adviser?", a: "No. Vardhix is a technology company. It is not a stockbroker, exchange, investment adviser, portfolio manager, or SEBI-registered intermediary unless separately confirmed." },
  { q: "How do I get support for Capital Tree Funding?", a: "For account-related support, please contact Capital Tree Funding through its official support channels at capitaltreefunding.com." },
  { q: "Do you offer partnerships or vendor engagements?", a: "Yes \u2014 use the enquiry form and select Business Partnership or Vendor Enquiry, and our team will reach out." },
  { q: "Where are you located?", a: "Our corporate office is in Pune, Maharashtra, India. The registered office will be published on this page." },
];

export const BUSINESS_HOURS = [
  { day: "Monday \u2013 Friday", hours: "9:30 AM \u2013 6:30 PM IST" },
  { day: "Saturday", hours: "10:00 AM \u2013 2:00 PM IST" },
  { day: "Sunday", hours: "Closed" },
];

export const CONTACT_CARDS = [
  { icon: "Building2", title: "Business & Partnerships", desc: "For enterprise, partnership and vendor enquiries.", value: "contact@vardhixtechnologies.com" },
  { icon: "Users", title: "Careers", desc: "Questions about roles and internships.", value: "contact@vardhixtechnologies.com" },
  { icon: "Sparkles", title: "Media & Press", desc: "For media enquiries and press.", value: "contact@vardhixtechnologies.com" },
];

export const FOOTER_RESOURCES = [
  { label: "What We Do", to: "/what-we-do" },
  { label: "Technologies", to: "/technologies" },
  { label: "Growth & Milestones", to: "/growth" },
  { label: "Our Platforms", to: "/platforms" },
];
